<div   class="relative z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 opacity-75"></div>

    <div class="fixed inset-0  overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <div class="pointer-events-auto w-screen max-w-2xl">
                    <div class="flex h-full flex-col overflow-y-auto rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                            <div class="px-4 sm:px-6 ">
                                <div class="flex items-start justify-between border-b border-gray-300 py-2">
                                    <h2 class="heading">
                                         Report Configuration</h2>
                                    <div class="ml-3 flex h-7 items-center">

                                        <button (click)="closeModal()"
                                            class="rounded-sm bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                            type="button">
                                            <span class="sr-only">Close panel</span>
                                            <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-6 flex-1 px-4 sm:px-6 h-3/5 overflow-y-scroll ">
                                <!-- <div class="grid grid-cols-2 gap-4 mb-8">
                                    <div>
                                        <label for="invoice-number" class="subheading">
                                            Funding Source
                                        </label>
                                        <div class="mt-1">
                                            <ng-select id="company" [(ngModel)]="selectedFundingSourceId" (change)="onSelectFundingSource($event)" [clearable]="false">
                                                <ng-option value="">Select Funding Source</ng-option>
                                                <ng-option *ngFor="let fundingSource of fundingSources" value="{{ fundingSource.id }}">
                                                    {{ fundingSource.title | titlecase }}
                                                </ng-option>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div> -->
                                <form [formGroup]="configurationForm" class="">
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>
                                            <label for="invoice-number"
                                                class="subheading">Invoice
                                                &#35;</label>
                                            <div class="mt-2">
                                                <input type="text" name="invoice-number" id="invoice-number" formControlName="invoiceNo">
                                            </div>
                                            
                                        </div>
                                        <div>
                                            <label for="invoice-number"
                                                class="subheading">Invoice Date
                                            </label>
                                            <div class="mt-2">
                                                <input type="text" name="invoiceDate" id="invoiceDate" formControlName="preInvoiceDate" [owlDateTime]="dtInvoice"
                                                    (ngModelChange)="changeInvoiceDate($event)" [owlDateTimeTrigger]="dtInvoice" [readonly]="true" />
                                                <owl-date-time #dtInvoice [pickerType]="'calendar'"></owl-date-time>
                                            </div>
                                        </div>
                                        <div>
                                            <label for="base-rate"
                                                class="subheading">Billed To <span class="text-red-600">*</span>
                                            </label>
                                            <div class="mt-2">
                                                <input type="text" name="base-rate" id="base-rate" formControlName="billingCompany">
                                            </div>
                                            <div *ngIf="form.billingCompany.errors && submitted">
                                                <div *ngIf="form.billingCompany.errors.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Billed To is required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label for="mileage-fee"
                                                class="subheading">
                                                Billing Company Address <span class="text-red-600">*</span>
                                             </label>
                                            <div class="mt-2">
                                                <input type="text" name="mileage-fee" id="mileage-fee" formControlName="billingAddress">
                                            </div>

                                            <div *ngIf="form.billingAddress.errors && submitted">
                                                <div *ngIf="form.billingAddress.errors.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Billing Address is required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label for="empty_miles"
                                                class="subheading">Billing
                                                Company Phone <span class="text-red-600">*</span>
                                            </label>
                                            <div class="mt-2">
                                                <input type="number" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" name="empty_miles" id="empty_miles" formControlName="billingCompanyPhone">
                                            </div>
                                             <div *ngIf="form.billingCompanyPhone.errors && submitted">
                                                <div *ngIf="form.billingCompanyPhone.errors.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Billing Company Phone is required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label for="discount"
                                                class="subheading">Billing
                                                Company Email <span class="text-red-600">*</span>
                                             </label>
                                            <div class="mt-2 ">
                                                <input type="text" name="discount" id="discount" formControlName="billingCompanyEmail">
                                            </div>
                                                <div *ngIf="form.billingCompanyEmail.errors && submitted">
                                                <div *ngIf="form.billingCompanyEmail.errors.required" class="error">
                                                    <p class="mt-2 text-red-600 text-xs">
                                                        Company Email is required
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label for="invoice-number"
                                                class="subheading">Due Date
                                            </label>
                                            <div class="mt-2">
                                                <input type="text" name="dueDate" id="dueDate" formControlName="preDueDate" [owlDateTime]="dtDueDate"
                                                    (ngModelChange)="changeDueDate($event)" [owlDateTimeTrigger]="dtDueDate" [readonly]="true" />
                                                <owl-date-time #dtDueDate [pickerType]="'calendar'"></owl-date-time>
                                            </div>
                                        </div>
                                        <div class="col-span-full">
                                        <h2 class="heading">
                                        Outstanding Invoices</h2>
                                            </div>
                                        <div>
                                            <label for="outstandingInvoiceNo"
                                                class="subheading">Invoice
                                                &#35; 
                                             </label>
                                            <div class="mt-2">
                                                <input type="number" name="outstandingInvoiceNo" id="outstandingInvoiceNo" formControlName="outstandingInvoiceNo">
                                            </div>
                                        </div>
                                        <div>
                                            <label for="pastDue"
                                               class="subheading">Past Due ($) 
                                                </label>
                                            <div class="mt-2">
                                                <input type="number" name="pastDue" id="pastDue" formControlName="pastDue">
                                            </div>
                                        </div>
                                        <!-- <div>
                                            <label for="corrections"
                                                class="block text-sm font-medium leading-6 text-gray-900">Total Items/Corrections ($)</label>
                                            <div class="mt-2">
                                                <input name="corrections" id="corrections"
                                                    formControlName="corrections"
                                                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                                            </div>
                                        </div> -->
                                    </div>

                                    <!-- --table-- -->
                                    <div class="mt-2 h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10" *ngIf="selectedTrips.length">
                                        <div class="mt-8 flow-root">
                                            <div class="-mx-4 -my-2 overflow-x-auto ">
                                                <div class="inline-block min-w-full py-2 align-middle ">
                                                    <table class="min-w-full divide-y divide-gray-300">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    ({{selectedTrips.length}})
                                                                </th>

                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    Date
                                                                </th>
                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    Name</th>
                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    Trip Id</th>
                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    Level Of Service</th>
                                                                <th scope="col"
                                                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                                    <span>Amount ($)</span>
                                                                </th>

                                                                <th scope="col "
                                                                    class="sr-only w-1/4 px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                                    Action
                                                                </th>

                                                            </tr>
                                                        </thead>
                                                        <tbody class="divide-y divide-gray-200">
                                                            <tr *ngFor="let trip of trips; let i = index">
                                                                <td
                                                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                    {{i + 1}}
                                                                </td>

                                                                <td
                                                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                     {{trip.pickup?.time | date: "MM/DD/YYYY"}}
                                                                </td>
                                                                <td
                                                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                  
                                                                   {{(trip.member?.displayName | titlecase)}}
                                                                </td>
                                                                <td
                                                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                    {{trip.reference}}-{{trip.suffix}}
                                                                </td>
                                                                <td
                                                                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                     <ng-container *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]">{{((preLevelOfService[trip.levelOfService].title) | uppercase)}}</ng-container>
                                                                </td>

                                                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                                                
                                                                    <span>
                                                                        <!-- {{ trip?.offeredFare?.total ? ('$' + trip?.offeredFare?.total) : 'N/A' }} -->
                                                                        {{trip?.specialRate && trip.specialRate > 0 ? '$' + trip.specialRate : trip?.offeredFare?.total ? '$' + trip.offeredFare.total : 'N/A'}}
                                                                    </span>
                                                                
                                                                </td>


                                                                <!-- <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 cursor-pointer"
                                                                    (click)="removeTrip(trip._id)">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                        viewBox="0 0 24 24" stroke-width="1.5"
                                                                        stroke="currentColor"
                                                                        class="w-6 h-6 text-red-400">
                                                                        <path stroke-linecap="round"
                                                                            stroke-linejoin="round"
                                                                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                                    </svg>

                                                                </td> -->

                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- --table-- -->


                                </form>

                            </div>
                            <div class="mt-4 px-6">
                                <div class="flex space-x-3 justify-end border-t border-gray-300 pt-2">
                                    <button type="button" (click)="downloadTripReport()"
                                        class="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                        <svg  *ngIf="reportLoader.isLoading" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            style="margin: auto; display: block; shape-rendering: auto;" class="h-6 w-8"
                                            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <path fill="none" stroke="#fff" stroke-width="8"
                                                stroke-dasharray="42.76482137044271 42.76482137044271"
                                                d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                                                stroke-linecap="round"
                                                style="transform:scale(0.8);transform-origin:50px 50px">
                                                <animate attributeName="stroke-dashoffset" repeatCount="indefinite"
                                                    dur="1s" keyTimes="0;1" values="0;256.58892822265625"></animate>
                                            </path>
                                        </svg>
                                        Download Report
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>